import axios from "axios";

const FALLBACK_MESSAGE =
  "Ha ocurrido un error inesperado. Por favor, intente nuevamente.";

const extractProblemDetails = (data) => {
  if (!data || typeof data !== "object") {
    return "";
  }

  if (typeof data.details === "string" && data.details.trim()) {
    return data.details;
  }

  if (typeof data.detail === "string" && data.detail.trim()) {
    return data.detail;
  }

  if (data.errors && typeof data.errors === "object") {
    const messages = Object.values(data.errors)
      .flat()
      .filter((value) => typeof value === "string" && value.trim());
    if (messages.length) {
      return messages.join("\n");
    }
  }

  if (typeof data.title === "string" && data.title.trim()) {
    return data.title;
  }

  if (typeof data.message === "string" && data.message.trim()) {
    return data.message;
  }

  return "";
};

export const handleError = (error) => {
  if (axios.isAxiosError(error)) {
    const problemMessage = extractProblemDetails(error.response?.data);
    if (problemMessage) {
      return problemMessage;
    }

    if (error.response?.status === 403) {
      return "No tiene permisos para realizar esta acción.";
    }

    if (error.response?.status === 401) {
      return "Su sesión ha expirado. Por favor, inicie sesión nuevamente.";
    }

    if (error.response?.status === 404) {
      return "El recurso solicitado no fue encontrado.";
    }

    if (error.response?.status >= 500) {
      return "Error interno del servidor. Por favor, intente nuevamente más tarde.";
    }

    if (typeof error.message === "string" && error.message.trim()) {
      return error.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return FALLBACK_MESSAGE;
};

export const toUserMessage = (value) => {
  if (value == null) {
    return FALLBACK_MESSAGE;
  }

  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }

  if (axios.isAxiosError(value) || value instanceof Error || value?.response) {
    return handleError(value);
  }

  const problemMessage = extractProblemDetails(value);
  if (problemMessage) {
    return problemMessage;
  }

  return FALLBACK_MESSAGE;
};
